import { render, staticRenderFns } from "./CompChoice.vue?vue&type=template&id=66d4136d&"
import script from "./CompChoice.vue?vue&type=script&lang=ts&"
export * from "./CompChoice.vue?vue&type=script&lang=ts&"
import style0 from "./CompChoice.vue?vue&type=style&index=0&id=66d4136d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports